<div class="flex flex-col gap-12">
  <div class="flex items-center justify-between">
    <app-title>{{ 'page.projects.title' | translate }}</app-title>
    <app-button appAdminAccess text="{{ 'page.projects.add' | translate }}" icon="/assets/images/icon-add.svg" (click)="createProject()"></app-button>
  </div>

  <app-tabs>
    <app-tab text="{{ 'page.projects.map' | translate }}" link="/panel/projects/map"></app-tab>
    <app-tab text="{{ 'page.projects.list' | translate }}" link="/panel/projects/list"></app-tab>
  </app-tabs>

  <div>
    <router-outlet></router-outlet>
  </div>
</div>
